import React from "react";
import { createGlobalStyle } from "styled-components";

import * as ELD from "~/ELD";
import * as Log from "~/Log";
import * as Modal from "~/Modal";
import * as Popover from "~/Popover";
import * as Tooltip from "~/Tooltip";

export const GlobalStyle = () => (
  <>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
    />
    <BodyStyle />
    <Log.Unassigned.Table.AntOverride.Component />
    <Modal.AntOverride.Component />
    <Popover.AntOverride.Component />
    <Tooltip.AntOverride.Component />
    <ELD.Page.LegacyOverride.Component />
    <Log.Unassigned.Page.LegacyOverride.Component />
  </>
);

const BodyStyle = createGlobalStyle`
  body, html {
    /* TODO: Reference design system gray 50. */
    background-color: rgba(247, 250, 253);

    font-family: "Roboto", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* TODO: Reference design system gray 900. */
    color: #1d2b39;

    cursor: default;
  }
`;
